<template>
    <div class="fixed bottom-24 right-5 z-9999999999999">
        <transition-group
            enter-active-class="transition duration-300 ease-out transform"
            enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
            leave-active-class="transition duration-150 ease-in"
            leave-from-class="opacity-0 opacity-100 sm:translate-x-0"
            leave-to-class="opacity-0 opacity-100 sm:translate-y-0 sm:translate-x-2"
        >
            <div
                v-for="notification in notifications"
                :key="notification.id"
                aria-live="assertive"
                class="mb-2 w-80"
            >
                <div
                    class="group pointer-events-auto w-full overflow-hidden rounded-lg bg-white shadow-md ring-1 ring-black ring-opacity-5 transition-all duration-150 hover:shadow-xl"
                >
                    <div class="p-4">
                        <div class="flex items-start">
                            <div class="shrink-0">
                                <div
                                    class="mt-1 h-3 w-3 rounded-full bg-blue-400"
                                    :class="{
                                        'bg-blue-400':
                                            notification.type === 'info',
                                        'bg-red-400':
                                            notification.type === 'error',
                                        'bg-green-400':
                                            notification.type === 'success',
                                        'bg-orange-400':
                                            notification.type === 'warning',
                                    }"
                                ></div>
                            </div>
                            <div class="ml-3 w-0 flex-1">
                                <p class="text-sm font-bold text-gray-800">
                                    {{ notification.title }}
                                </p>
                                <p
                                    v-if="notification.text !== undefined"
                                    class="mt-1 text-sm text-gray-500"
                                >
                                    {{ notification.text }}
                                </p>
                            </div>
                            <div class="ml-4 flex shrink-0">
                                <button
                                    class="duration-350 absolute right-2 hidden rounded-md bg-white text-gray-400 transition-all hover:text-gray-500 focus:outline-hidden focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 group-hover:inline-flex"
                                    @click="remove(notification.id)"
                                >
                                    <span class="sr-only">Close</span>
                                    <XMarkIcon
                                        class="h-5 w-5"
                                        aria-hidden="true"
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition-group>
    </div>
</template>

<script lang="ts" setup>
import { notifications, remove } from "@/composables/useNotifications";
import { XMarkIcon } from "@heroicons/vue/24/solid";
</script>
